import { render, staticRenderFns } from "./group-name.vue?vue&type=template&id=46b5feba&scoped=true"
import script from "./group-name.vue?vue&type=script&lang=js"
export * from "./group-name.vue?vue&type=script&lang=js"
import style0 from "./group-name.vue?vue&type=style&index=0&id=46b5feba&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "46b5feba",
  null
  
)

export default component.exports